import { Controller } from "@hotwired/stimulus";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "../components/masse-grasse/App";

export default class extends Controller {
    connect() {
        ReactDOM.createRoot(this.element).render(<App />);
    }
}
